export default "__VITE_ASSET__BrvVyW9t__"